export default __webpack_public_path__ + "static/media/Major Rune Stone of the Tireless Defender (V).1234a19a.jpg";